import React from 'react';
import PartnerEditContainer from '../../containers/partnermng/PartnerEditContainer';


const PartnerEditPage = () => {
  return <PartnerEditContainer />;
};

export default PartnerEditPage;
